import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import '../styles/NavMenu.css';
import { Link } from 'react-router-dom';
import { appService } from '../_services';
import { userService } from '../_services';
import { authHeader, config } from '../_helpers'
import { Redirect, Route } from 'react-router-dom';
import CookieConsent, { Cookies } from "react-cookie-consent";
import queryString from 'query-string';
import ReactGA from 'react-ga';
import Banner from './Banner';
let CartCount = 0;

export class HeaderComponent extends Component {
    displayName = HeaderComponent.name
    constructor(props) {
        super(props);
        this.state = {
            login: false,
            UserSubscription: [],
            authorName: "",
            loginhome: false,
            clearCookies: false,
        },
            this.handleAuthIpAndRef = this.handleAuthIpAndRef.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            authorName: nextProps.AuthorName
        });

        var hours = 12;//
        var now = new Date().getTime();
        var setupTime = localStorage.getItem('setupTime');

        if (localStorage.getItem('user') !== null && setupTime == null) {
            localStorage.clear();
            window.location.reload();
            //this.setState({ login: false });
            //this.setState({ loginhome: false });
        }
        else if (setupTime != null) {
            if (now - setupTime > hours * 60 * 60 * 1000) {
                localStorage.clear();
                window.location.reload();
                //this.setState({ login: false });
                //this.setState({ loginhome: false });
                //window.location.reload();
            }
        }

    }

    componentWillMount() {
        if (localStorage.getItem('logoutclick') == 'true') {
            localStorage.removeItem('logoutclick');
        }
        else {
            //if (localStorage.getItem('version') == null || localStorage.getItem('version') != "1.0") {
            //    localStorage.removeItem('user');
            //    localStorage.removeItem('userId');
            //    localStorage.removeItem('usersubscription');
            //    localStorage.removeItem('company');
            //    localStorage.removeItem('firstName');
            //    localStorage.removeItem('lastName');
            //    localStorage.removeItem('salesForceID');
            //    localStorage.setItem('logoutclick', 'true');
            //    localStorage.setItem('version', '1.0');
            //    //window.location.reload(true);
            //    this.setState({ clearCookies: true });
            //}

            var hours = 12;//
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('setupTime');

            if (localStorage.getItem('user') !== null && setupTime == null) {
                localStorage.clear();
                window.location.reload();
                //this.setState({ login: false });
                //this.setState({ loginhome: false });
            }
            else if (setupTime != null) {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.clear();
                    this.setState({ clearCookies: true });
                    //this.setState({ login: false });
                    //this.setState({ loginhome: false });
                    window.location.reload();
                }
                //else {
                //    localStorage.setItem('setupTime', new Date().getTime());
                //}
            }

            if (localStorage.getItem('user') !== null && localStorage.getItem('salesForceID') !== null) {
                var user = localStorage.getItem('user').replace("\"", "").replace("\"", "")
                userService.loginTemp('User/SetSession?user=' + user)
                    .then(function (data) {
                    })
            }
            else {
                this.handleAuthIpAndRef();
                if (localStorage.getItem('user') !== null && localStorage.getItem('salesForceID') !== null) {
                    window.location.reload();
                }
            }
        }
    }

    componentDidMount() {

        //if (localStorage.getItem('version') == null || localStorage.getItem('version') != "1.0") {
        //    localStorage.removeItem('user');
        //    localStorage.removeItem('userId');
        //    localStorage.removeItem('usersubscription');
        //    localStorage.removeItem('company');
        //    localStorage.removeItem('firstName');
        //    localStorage.removeItem('lastName');
        //    localStorage.removeItem('salesForceID');
        //    localStorage.setItem('logoutclick', 'true');
        //    localStorage.setItem('version', '1.0');
        //    //window.location.reload(true);
        //    this.setState({ clearCookies: true });
        //}

        var hours = 12;//
        var now = new Date().getTime();
        var setupTime = localStorage.getItem('setupTime');

        if (localStorage.getItem('user') !== null && setupTime == null) {
            localStorage.clear();
            this.setState({ clearCookies: true });
            //this.setState({ login: false });
            //this.setState({ loginhome: false });
        }
        else if (setupTime != null) {
            if (now - setupTime > hours * 60 * 60 * 1000) {
                localStorage.clear();
                this.setState({ clearCookies: true });
                //this.setState({ login: false });
                //this.setState({ loginhome: false });
                //window.location.reload();
            }
        }

        if (localStorage.getItem('user') !== null && localStorage.getItem('salesForceID') !== null) {
            var user = localStorage.getItem('user').replace("\"", "").replace("\"", "")
            userService.loginTemp('User/SetSession?user=' + user)
                .then(function (data) {
                })
        }
        if (localStorage.getItem('user') !== null && localStorage.getItem('salesForceID') !== null) {
            var parameters = { user: JSON.parse(localStorage.getItem('user')) };
            appService.getByIssueId('Product/GetSubscriptionDetail', parameters)
                .then(function (data) {
                    self.setState({ UserSubscription: data });
                });
        }
        appService.getAll('Cart/GetCartProductCountByUserId')
            .then(function (data) {
                CartCount = data;
            });
        var self = this;
        if (localStorage.getItem('user') !== null && localStorage.getItem('salesForceID') !== null) {
            self.setState({ login: true });
        }
        else {
            self.setState({ login: false });
        }
    }
    updateParent(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch) {
        this.props.layoutCallback(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch);
    }

    handleAuthIpAndRef() {
        var self = this;

        if (document.location.href.includes("casa_token=")) {
            const requestOptions = {
                method: 'GET',
                headers: authHeader(),
            };

            var url = window.location.search;
            var params = queryString.parse(url);
            var token = "";
            if (params.casa_token) {
                token = params.casa_token;
            }

            fetch(config.apiUrl + '/User/Check_CASA_Token?token=' + token, requestOptions)
                .then(this.handleResponse, this.handleError)
                .then(function (userSubscription) {
                    if (userSubscription != null && userSubscription != 'undefined' && userSubscription.username != null) {
                        localStorage.setItem('company', userSubscription.company);
                        localStorage.setItem('firstName', userSubscription.firstName);
                        localStorage.setItem('lastName', userSubscription.lastName);
                        localStorage.setItem('user', JSON.stringify(userSubscription.username));
                        localStorage.setItem('usersubscription', userSubscription.userSubscription);
                        localStorage.setItem('userId', userSubscription.id);
                        localStorage.setItem('salesForceID', userSubscription.customerID);
                        localStorage.setItem('version', '1.0');
                        localStorage.setItem('setupTime', new Date().getTime());
                        self.setState({ login: true });
                        self.setState({ loginhome: true });
                    }
                });
        }

        // if (document.location.href.includes("OIDC") && document.location.href.split("@")[1] != null && document.location.href.split("@")[1] != '' && document.location.href.split("@")[1] != 'undefined') {
        if (document.location.href.includes("OIDC=")) {
            //Authenticate by openAthensUrl
            const requestOptions = {
                method: 'GET',
                headers: authHeader(),
            };
            fetch(config.apiUrl + '/User/CheckOpenAthensUrl?openAthensUrl=' + document.location.href, requestOptions)
                .then(this.handleResponse, this.handleError)
                .then(function (userSubscription) {
                    if (userSubscription != null && userSubscription != 'undefined' && userSubscription.username != null) {
                        localStorage.setItem('company', userSubscription.company);
                        localStorage.setItem('firstName', userSubscription.firstName);
                        localStorage.setItem('lastName', userSubscription.lastName);
                        localStorage.setItem('user', JSON.stringify(userSubscription.username));
                        localStorage.setItem('usersubscription', userSubscription.userSubscription);
                        localStorage.setItem('userId', userSubscription.id);
                        localStorage.setItem('salesForceID', userSubscription.customerID);
                        localStorage.setItem('version', '1.0');
                        localStorage.setItem('setupTime', new Date().getTime());
                        self.setState({ login: true });
                        self.setState({ loginhome: true });
                    }
                });
        }

        if (document.referrer != null && document.referrer != '') {
            //Authenticate by Referrer URL
            const requestOptions = {
                method: 'GET',
                headers: authHeader(),
            };
            fetch(config.apiUrl + '/User/CheckReferrerUrl?referrerUrl=' + document.referrer, requestOptions)
                .then(this.handleResponse, this.handleError)
                .then(function (userSubscription) {

                    if (userSubscription != null && userSubscription != 'undefined' && userSubscription.username != null) {
                        localStorage.setItem('company', userSubscription.company);
                        localStorage.setItem('firstName', userSubscription.firstName);
                        localStorage.setItem('lastName', userSubscription.lastName);
                        localStorage.setItem('user', JSON.stringify(userSubscription.username));
                        localStorage.setItem('usersubscription', userSubscription.userSubscription);
                        localStorage.setItem('userId', userSubscription.id);
                        localStorage.setItem('salesForceID', userSubscription.customerID);
                        localStorage.setItem('version', '1.0');
                        localStorage.setItem('setupTime', new Date().getTime());
                        self.setState({ login: true });
                        self.setState({ loginhome: true });
                    }
                });
        }

        //Authenticate by IP
        const requestOptions = {
            method: 'GET',
            headers: authHeader(),
        };
        fetch(config.apiUrl + '/User/CheckIPRange', requestOptions).then(this.handleResponse, this.handleError)
            .then(function (userSubscription) {

                if (userSubscription != null && userSubscription != 'undefined' && userSubscription.username != null) {
                    localStorage.setItem('company', userSubscription.company);
                    localStorage.setItem('firstName', userSubscription.firstName);
                    localStorage.setItem('lastName', userSubscription.lastName);
                    localStorage.setItem('user', JSON.stringify(userSubscription.username));
                    localStorage.setItem('usersubscription', userSubscription.userSubscription);
                    localStorage.setItem('userId', userSubscription.id);
                    localStorage.setItem('salesForceID', userSubscription.customerID);
                    localStorage.setItem('version', '1.0');
                    localStorage.setItem('setupTime', new Date().getTime());
                    self.setState({ login: true });
                    self.setState({ loginhome: true });
                    //   return true;
                }
            });

    }
    handleResponse(response) {
        return new Promise((resolve, reject) => {
            if (response.ok) {
                // return json if it was returned in the response
                var contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    response.json().then(json => resolve(json));
                } else {
                    resolve();
                }
            } else {
                // return error message from response body
                response.text().then(text => reject(text));
            }
        });
    }

    handleError(error) {
        return Promise.reject(error && error.message);
    }

    render() {

        if (this.state.clearCookies) {
            this.state.clearCookies = false;
            return <Redirect to={"../"} />
        }
        //else {
        //    this.setState({ clearCookies: false });
        //}

        if (this.state.loginhome) {
            this.setState({ loginhome: false });

            if (document.location.pathname == "/Login") {
                return <Redirect to={"../LoginHome"} />
            }
            else {
                window.location.reload();
            }
        }

        return (
            <header>
                <CookieConsent
                    location="top"
                    buttonText="I AGREE"
                    cookieName="KluwerLawOnline"
                    style={{ background: "#777", fontFamily: 'Fira Sans' }}
                    buttonStyle={{
                        position: "relative",
                        width: "100px",
                        height: "50px",
                        color: "#fff",
                        padding: "6px 12px",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        display: "inline-block",
                        fontWeight: "400",
                        border: "1px solid #fff",
                        background: "0 0",
                        msBorderRadius: "0",
                        borderRadius: "0",
                        margin: "0",
                        lineHeight: "1.42857143",
                        textAlign: "center",
                        fontSize: "13px",
                        verticalAlign: "middle",
                        cursor: "pointer",
                        marginLeft: '1%'
                    }}
                    expires={900}
                >
                    <p>
                        We use cookies on this site to provide you with an informative and engaging experience and also to help us to continually improve our site for you. Without allowing cookies certain features of the site will not be available. To learn more about how we use cookies, please view our <a style={{ color: '#fff', textDecoration: 'underline' }} href="http://www.kluwerlaw.com/privacy-policy/">cookie policy</a>. By clicking on ‘I AGREE’, you consent to our use of cookies on this device in accordance with our policy.
                    </p>
                </CookieConsent>
                <div className="col-12">
                    <div className="row">
                        <div className="col">
                            <Link to="/"><img src="/../../images/WK.png" alt="Logo of Wolters Kluwer, Kluwer Law Online" className="img"></img></Link>
                        </div>
                        <div className="col">
                        </div>
                        {localStorage.getItem('user') !== null ?
                            <div className="col-lg-2 margintop">
                                <Link className="LinkClass pull-right" id="HeaderFeedback" to="/Feedback">Feedback & support </Link>
                            </div>
                            :
                            null
                        }
                        {localStorage.getItem('user') !== null ?
                            <div className="col-lg-2 margintop">
                                <Link className="LinkClass" id="HeaderAlert" to="/Subscription">Your Subscriptions</Link>
                            </div>
                            : null
                        }

                    </div>

                   <Banner/>

                    <NavMenu headerCallback={this.updateParent.bind(this)} AuthorName={this.state.authorName} />

                </div>

            </header>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.jsx